window.addEventListener('unhandledrejection', (event) => {
  const msg = event.reason?.message ?? '';

  const isChunkLoadError =
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Importing a module script failed') ||
    event.reason?.name === 'ChunkLoadError';

  if (isChunkLoadError && !sessionStorage.getItem('chunk_reload')) {
    sessionStorage.setItem('chunk_reload', '1');
    window.location.reload();
  }
});
